var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var FloatingPanel_1;
import React, { PureComponent } from 'react';
import { Rnd } from 'react-rnd';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { DocumentContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { number, oneOfType, shape, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { isUndefined } from '@philips-internal/oswald-ui-utils';
import DragGrip from './draggable-grip.js';
import FloatingPanelAPI from './floating-panel-api.js';
import './floating-panel.css';
const FloatingpanelContainer = {
    name: '',
};
let FloatingPanel = FloatingPanel_1 = class FloatingPanel extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            height: 400,
            position: {
                x: 0,
                y: 0,
            },
            width: 400,
        };
        this.onDragStop = (_event, data) => {
            this.setState({
                position: {
                    x: data.x,
                    y: data.y,
                },
            });
        };
        this.onResize = (element, position) => {
            this.setState({
                height: element.offsetHeight,
                position,
                width: element.offsetWidth,
            });
        };
        this.formatMeasures = (input) => {
            if (typeof input === 'number') {
                return input;
            }
            const numberValue = Number(input);
            return isNaN(numberValue) ? input : numberValue;
        };
    }
    componentDidMount() {
        const { initialPosition } = this.props;
        if (!isUndefined(initialPosition)) {
            this.setState({ position: initialPosition });
        }
    }
    render() {
        const { children, maxHeight = FloatingPanel_1.defaultProps.maxHeight, maxWidth = FloatingPanel_1.defaultProps.maxWidth, minHeight = FloatingPanel_1.defaultProps.minHeight, minWidth = FloatingPanel_1.defaultProps.minWidth, uuid, } = this.props;
        const { height, position, width } = this.state;
        const defaultProps = {
            ...position,
            height,
            width,
        };
        return (React.createElement(Rnd, { bounds: "parent", className: "c-floating-panel", default: defaultProps, maxHeight: this.formatMeasures(maxHeight), maxWidth: this.formatMeasures(maxWidth), minHeight: this.formatMeasures(minHeight), minWidth: this.formatMeasures(minWidth), onDragStop: this.onDragStop, onResize: (_e, _direction, ref, _delta, position) => this.onResize(ref, position), position: position },
            React.createElement(Container, { className: "c-floating-panel__container", uuid: uuid }, children),
            React.createElement(DragGrip, { height: height })));
    }
};
FloatingPanel.contextType = DocumentContext;
FloatingPanel.propTypes = {
    initialPosition: shape({ x: number, y: number }),
    maxHeight: oneOfType([string, number]),
    maxWidth: oneOfType([string, number]),
    minHeight: oneOfType([string, number]),
    minWidth: oneOfType([string, number]),
    uuid: string,
};
FloatingPanel.defaultProps = {
    maxHeight: 600,
    maxWidth: 700,
    minHeight: 400,
    minWidth: 400,
};
FloatingPanel = FloatingPanel_1 = __decorate([
    AwesomeComponent({ api: FloatingPanelAPI, containers: [FloatingpanelContainer], type: ComponentType.LAYOUT })
], FloatingPanel);
export { FloatingPanel, };
export default FloatingPanel;
//# sourceMappingURL=floating-panel.js.map